"use client";

import { Mail, MessageCircleMore } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function AdditionalContactInformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const contactItems = [{
    id: 1,
    icon: MessageCircleMore,
    // WhatsApp-ähnliches Icon
    label: "Telefon",
    value: "0160 3284613"
  }, {
    id: 2,
    icon: Mail,
    label: "E-Mail",
    value: "info.namo@icloud.com"
  }];
  return <section className="relative py-16 px-6">
      <div className="container mx-auto max-w-6xl">
        <Card ref={ref} className="relative overflow-hidden bg-secondary-light border-secondary/20">
          <div className="absolute inset-0 opacity-[0.04] pointer-events-none bg-repeat" style={{
          backgroundImage: `radial-gradient(circle, hsl(90, 61%, 15%) 1px, transparent 1px)`,
          backgroundSize: "24px 24px"
        }} />

          <div className="relative grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 p-8 md:p-12">
            {contactItems.map((item, i) => {
            const Icon = item.icon;
            return <div key={item.id} data-index={i} className="flex flex-col items-center text-center group transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-[1.02] hover:shadow-soft">
                  <div className={`mb-4 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
                transitionDelay: `${i * 100}ms`
              }}>
                    <Icon className="w-10 h-10 text-accent-dark" strokeWidth={2} aria-hidden="true" />
                  </div>

                  <h3 className="font-display text-lg font-semibold text-primary mb-2 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:-translate-y-2">
                    {item.label}
                  </h3>

                  <p className="text-sm font-sans font-bold" style={{
                color: "#436C1A"
              }}>
                    {item.value}
                  </p>
                </div>;
          })}
          </div>
        </Card>
      </div>
    </section>;
}